module.exports = __webpack_public_path__ + "static/img/gtm-desc-3.fddabf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/gtm-desc-3.png
// module id = oDjd
// module chunks = 0 139